<div class="card-header">
    <div class="row">
        <div class="col-10">Notifikationer</div>
        <div class="col-2 text-end"><i class="card-header__icon fa fa-bell"></i></div>
    </div>
</div>
<div class="card-body">
    <div class="table-responsive">
        <table class="notificationTable table table-hover table-striped table-sm">
            <tbody>
                <tr *ngFor="let notification of notifications" (click)="modalsService.methodCall(notification.key)">
                    <td>{{ notification.cardLabel }}</td>
                    <td class="notificationTable__number">{{ notification.count }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
